import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-modal';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile';
import './Navbar.css';
import Favoritos from '../Favoritos/Favoritos';
import InputSerach from '../InputSerach/InputSearchs';
import Cart from '../Cart/Cart';
import { useCategoria } from '../CategoriaContext';
import useIsMobile from './useIsMobile';
import moneda from '../moneda';

export default function Navbar({ logo }) {
    const [isOpen, setIsOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [categorias, setCategorias] = useState([]);
    const [showCategorias, setShowCategorias] = useState(false);
    const categoriasBtnRef = useRef(null);
    const categoriasDropdownRef = useRef(null);
    const { setCategoriaSeleccionada } = useCategoria();
    const isMobile = useIsMobile();
    const [cartTotal, setCartTotal] = useState(0);

    useEffect(() => {
        cargarBanners();
        cargarCategorias();
        calcularTotalCarrito();
        // Escuchar cambios en localStorage (por ejemplo, desde otras pestañas o componentes)
        const handleStorage = (e) => {
            if (e.key === 'cart') {
                calcularTotalCarrito();
            }
        };
        window.addEventListener('storage', handleStorage);
        window.addEventListener('cartUpdated', calcularTotalCarrito);
        return () => {
            window.removeEventListener('storage', handleStorage);
            window.removeEventListener('cartUpdated', calcularTotalCarrito);
        };
    }, []);

    const cargarBanners = () => {
        fetch(`${baseURL}/api/banners`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const bannerImages = data.banner.map(banner => banner.imagen);
                setImages(bannerImages);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)
            });
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/api/categorias`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const calcularTotalCarrito = () => {
        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        let total = 0;
        cart.forEach(item => {
            total += (item.precio || 0) * (item.cantidad || 1);
        });
        setCartTotal(total);
    };

    // Cerrar el menú si se hace clic fuera
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                categoriasDropdownRef.current &&
                !categoriasDropdownRef.current.contains(event.target) &&
                categoriasBtnRef.current &&
                !categoriasBtnRef.current.contains(event.target)
            ) {
                setShowCategorias(false);
            }
        }
        if (showCategorias) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showCategorias]);

    return (
        <header>
            {isMobile ? (
                // NAVBAR MÓVIL
                <>
                <nav className="navbar-main-custom navbar-mobile">
                    <button className="navbar-hamburger" aria-label="Abrir menú" onClick={() => setMenuOpen(v => !v)}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="3" y1="6" x2="21" y2="6" />
                            <line x1="3" y1="12" x2="21" y2="12" />
                            <line x1="3" y1="18" x2="21" y2="18" />
                        </svg>
                    </button>
                    <Anchor to={`/`} className='logo'>
                        <img src={logo} alt="logo" style={{ height: '32px' }} />
                    </Anchor>
                    <div className="navbar-mobile-right">
                        <div className="navbar-icon-circle">
                            <InputSerach />
                        </div>
                        <div className="navbar-icon-circle">
                            <Favoritos />
                        </div>
                        <div className="navbar-icon-circle navbar-cart-group">
                            <Cart />
                        </div>
                    </div>
                </nav>
                {menuOpen && (
                    <div className="navbar-mobile-menu" onClick={() => setMenuOpen(false)}>
                        <div className="navbar-mobile-menu-inner" onClick={e => e.stopPropagation()}>
                            <button className="navbar-mobile-menu-close" onClick={() => setMenuOpen(false)} aria-label="Cerrar menú">✕</button>
                            <div className="navbar-mobile-menu-cats">
                                <p className="navbar-mobile-menu-title">Categorías</p>
                                {categorias.map(cat => (
                                    <button
                                        key={cat.idCategoria}
                                        className="navbar-mobile-menu-cat-item"
                                        onClick={() => { setCategoriaSeleccionada(cat.idCategoria); setMenuOpen(false); }}
                                    >
                                        {cat.categoria}
                                    </button>
                                ))}
                            </div>
                            <div className="navbar-mobile-menu-profile">
                                <button className="navbar-profile-btn" onClick={() => { setIsOpen(true); setMenuOpen(false); }}>
                                    <svg width="20" height="20" fill="none" stroke="var(--color1)" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-7 8-7s8 3 8 7"/></svg>
                                    Mi cuenta
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay"
                >
                    <div className="modalNav-content">
                        {loading ? (
                            <div className='loadingBannerFondo'></div>
                        ) : (
                            <>
                                <div className='fondo'>
                                    <img src={images[0]} alt="fondo" />
                                </div>
                                <Profile />
                            </>
                        )}
                    </div>
                </Modal>
                </>
            ) : (
                // NAVBAR ESCRITORIO (como ya la tienes)
                <>
                    {/* NAVBAR PRINCIPAL */}
                    <nav className="navbar-main-custom">
                        <div className="navbar-main-left">
                            <Anchor to={`/`} className='logo'>
                                <img src={logo} alt="logo" />
                            </Anchor>
                        </div>
                        <div className="navbar-main-center">
                            <InputSerach />
                        </div>
                        <div className="navbar-main-right">
                            <div className="navbar-icon-circle">
                                <Favoritos />
                            </div>
                            <div className="navbar-icon-circle">
                                {/* Perfil: puedes poner un ícono o modal si lo tienes */}
                                <button className="navbar-profile-btn" onClick={() => setIsOpen(true)}>
                                    <svg width="20" height="20" fill="none" stroke="var(--color1)" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-7 8-7s8 3 8 7"/></svg>
                                </button>
                            </div>
                            <div className="navbar-icon-circle navbar-cart-group">
                                <Cart />
                                <span className="navbar-cart-total">{moneda} {cartTotal.toLocaleString()}</span>
                            </div>
                        </div>
                    </nav>
                    {/* MODAL PERFIL */}
                    <Modal
                        isOpen={isOpen}
                        onRequestClose={() => setIsOpen(false)}
                        className="modalNav"
                        overlayClassName="overlay"
                    >
                        <div className="modalNav-content">
                            {loading ? (
                                <div className='loadingBannerFondo'></div>
                            ) : (
                                <>
                                    <div className='fondo'>
                                        <img src={images[0]} alt={`imagen`} />
                                    </div>
                                    <Profile />
                                </>
                            )}
                        </div>
                    </Modal>
                    {/* BARRA SECUNDARIA */}
                    <div className="navbar-secondary-custom">
                        <div className="navbar-secondary-categories" style={{position:'relative'}}>
                            <button className="navbar-categories-btn" ref={categoriasBtnRef} onClick={() => setShowCategorias(v => !v)}>
                                <span className="navbar-categories-icon">▦</span> Categorías <span style={{fontSize: '12px'}}>▼</span>
                            </button>
                            {showCategorias && (
                                <div className="navbar-categorias-dropdown" ref={categoriasDropdownRef}>
                                    {categorias.length === 0 && <div className="navbar-categorias-dropdown-item">Cargando...</div>}
                                    {categorias.map(cat => (
                                        <button className="navbar-categorias-dropdown-item" key={cat.idCategoria} onClick={() => { setCategoriaSeleccionada(cat.idCategoria); setShowCategorias(false); }}>
                                            {cat.categoria}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="navbar-secondary-links">
                            <Anchor to="/">Inicio</Anchor>
                        </div>
                    </div>
                </>
            )}
        </header>
    );
}
